import { useRef, useState } from "react";
import { motion as motionReact } from "motion/react";
import "animate.css";
import { motion } from "framer-motion";
import { displayDeck } from "../../Services/displayDeck";
import { displayDeckConfig } from "../../constants";
import "./Card.css";
import { useDarkMode } from "../../Services/Context/DarkModeContext";
import { useUtilImages } from "../../Services/Hooks/useUtilImages";

const Card = ({
  handleIsTouchedClick,
  isReversedCardsEnabled,
  onCardRevealed,
  excludedCardNames,
}: {
  handleIsTouchedClick: () => void;
  isReversedCardsEnabled: boolean;
  onCardRevealed?: (cardName: string, isReversed: boolean) => void;
  excludedCardNames?: string[];
}) => {
  const { dark } = useDarkMode();
  const { cardBack } = useUtilImages();
  const cardData = useRef(
    displayDeck({ deckConfig: displayDeckConfig.SINGLE_CARD, excludedCardNames }),
  ).current;
  const animationType = useRef(
    [
      "animate__zoomInUp",
      "animate__zoomInRight",
      "animate__zoomInLeft",
      "animate__zoomInDown",
      "animate__zoomIn",
    ][Math.floor(Math.random() * 5)],
  ).current;
  const isUpsideDown = useRef(Math.random() < 0.5).current;
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = () => {
    if (!isFlipped) {
      setIsFlipped(true);
      handleIsTouchedClick();
      if (onCardRevealed) {
        // Wait for the 1s flip animation to complete before reporting
        setTimeout(() => {
          onCardRevealed(
            cardData.cardName,
            isReversedCardsEnabled && isUpsideDown,
          );
        }, 1000);
      }
    }
  };

  return (
    <motionReact.div
      drag
      animate={isFlipped ? { x: 0, y: 0 } : {}}
      className={`animate__animated ${animationType}`}
    >
      <motion.div className="Deck">
        <motion.div
          className="Deck-card"
          animate={{ rotateY: isFlipped ? 180 : 0 }}
          transition={{ duration: 1 }}
        >
          <motion.div className="Deck-card-front">
            <section>
              <div className="Deck-card-img-container" onClick={handleClick}>
                <img src={cardBack} className="Deck-card-img" alt="card back" />
              </div>
            </section>
          </motion.div>
          <motion.div className="Deck-card-back">
            <section style={{ display: dark ? "hidden" : "" }}>
              <div className="Deck-card-img-container" onClick={handleClick}>
                <img
                  src={cardData.image}
                  className={`Deck-card-img ${
                    isReversedCardsEnabled && isUpsideDown
                      ? "Deck-card-upsidedown"
                      : ""
                  }`}
                  alt={cardData.cardName}
                />
              </div>
            </section>
          </motion.div>
        </motion.div>
      </motion.div>
    </motionReact.div>
  );
};

export default Card;
